import { grey } from "@mui/material/colors";
import { LogProps } from "../../user/types/log";
import { palette } from "../../../shared/styles/theme";

export type ResponseCategory = "restriction" | "observation" | "debit";

export type ResponseStatus = "green" | "yellow" | "red" | "gray";

export type ResponseKeyType = "code" | "text";

export type ResponseClassificationProps = {
	id: string;
	api: string;
	api_name: string;
	source_field: string;
	key_type: ResponseKeyType;
	key: string;
	category: ResponseCategory;
	status: ResponseStatus;
	label: string | null;
	created_at: string;
	updated_at: string;
	is_active: boolean;
	created_by_email: string | null;
	updated_by_email: string | null;
};

export type ListResponseClassificationProps = {
	user: LogProps;
	content: {
		count: number;
		next: string | null;
		previous: string | null;
		results: ResponseClassificationProps[];
	};
};

export const categoryLabel: Record<ResponseCategory, string> = {
	restriction: "Restrição",
	observation: "Observação",
	debit: "Débito",
};

export const statusLabel: Record<ResponseStatus, string> = {
	green: "Verde",
	yellow: "Amarelo",
	red: "Vermelho",
	gray: "Cinza",
};

export const keyTypeLabel: Record<ResponseKeyType, string> = {
	code: "Código",
	text: "Texto",
};

export const activeLabel = (isActive: boolean) => (isActive ? "Sim" : "Não");

export const statusColor: Record<ResponseStatus, string> = {
	green: palette.success.main,
	yellow: palette.warning.main,
	red: palette.error.main,
	gray: grey[500],
};
